import React, { useState, useRef, useEffect } from "react";
import TransferSenderSelectComponent from "./transferSenderSelect.component";
import { selectLoading } from "modules/notification";
import TransferSenderSelectPanelComponent from "./transferSenderSelectPanel.component";
import { getTransferSenderDropdown } from "modules/stockflow/redux";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";
import customFeatureApi from "app/api/customFeature/prife";

function TransferSenderSelectContainer({
  handleChange,
  disabled,
  value,
  styles,
  textStyles,
  placeholder,
  companyId,
}) {
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransferSenderDropdown.typePrefix)
  );
  const transferSenderDropdown = useSelector(
    (state) => state.stockflowTransfer.transferSenderDropdown
  );
  const lang = useSelector((state) => state.constant.languages);
  const prifeCompanyList = [57, 85, 108];
  const isPrifeCompany = prifeCompanyList.includes(companyId);
  const [prifeSenderDropdown, setPrifeSenderDropdown] = useState([]);
  const [isPrifeFetching, setIsPrifeFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (isPrifeCompany) {
      setIsPrifeFetching(true);
      customFeatureApi
        .getPrifeReceiveTransferSenderDropdown({ search })
        .then((res) => {
          const data = res?.data ?? res;
          setPrifeSenderDropdown(Array.isArray(data) ? data : []);
        })
        .catch(() => setPrifeSenderDropdown([]))
        .finally(() => setIsPrifeFetching(false));
    } else {
      dispatch(getTransferSenderDropdown({ search }));
    }
  }, [search, dispatch, isPrifeCompany]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    const dropdown = isPrifeCompany
      ? prifeSenderDropdown
      : transferSenderDropdown;
    setSelectAll(value.length === dropdown.length);
  }, [value, transferSenderDropdown, prifeSenderDropdown, isPrifeCompany]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleSelectAll = async () => {
    const dropdown = isPrifeCompany
      ? prifeSenderDropdown
      : transferSenderDropdown;
    if (!selectAll) {
      const selectedSender = dropdown.map((p) => p.uuid);
      handleChange(selectedSender);
    } else {
      handleChange([]);
    }
  };

  const handleSelectSender = (sender) => {
    let temp = cloneDeep(value);

    if (temp.findIndex((t) => t === sender.uuid) >= 0) {
      temp = temp.filter((t) => t !== sender.uuid);
    } else {
      temp.push(sender.uuid);
    }
    handleChange(temp);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <>
      <TransferSenderSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <TransferSenderSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isPrifeCompany ? isPrifeFetching : isFetching}
        transferSenderDropdown={
          isPrifeCompany ? prifeSenderDropdown : transferSenderDropdown
        }
        handleSelectAll={handleSelectAll}
        handleSelectSender={handleSelectSender}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

export default TransferSenderSelectContainer;
